import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'appliedThroughUCAS' | 'ucasPin'>;

type Params = Fields;

export function getPageStatus({ appliedThroughUCAS, ucasPin }: Params): { complete: boolean } {
  let complete = false;
  if (appliedThroughUCAS === undefined || (appliedThroughUCAS === true && (ucasPin === undefined || ucasPin === ''))) {
    complete = false;
  } else {
    complete = true;
  }

  return { complete };
}
